import React from 'react';
import { Box, TextField } from '@material-ui/core';
import CardTitle from '../../../components/sharedComponents/CardTitle/index';
import TablePostVenta from '../../../components/reports/postVenta/TablePostVenta';
import { Button, useStyles } from './styles';

const MotomaxFinder = (props) => {
  const {
    spareParts,
    onChangeInput,
    onSubmitSearch,
  } = props;

  const columns = [
    { title: 'CÓDIGO', field: 'codigo' },
    { title: 'NOMBRE', field: 'nombre_empresa' },
    { title: 'DESCRIPCIÓN', field: 'descripcion' },
    { title: 'CANTIDAD/UNIDADES', field: 'cantidad' },
    { title: 'CÓDIGO BODEGA', field: 'codigo_bodega' },
  ];
  const classes = useStyles();

  return (
    <>
      <CardTitle title="Buscador MotoMax" />
      <Box
        component="form"
        onSubmit={onSubmitSearch}
        className={classes.formContainer}
      >
        <TextField
          type="number"
          className={classes.input}
          label="Código SAP"
          required
          variant="outlined"
          onChange={(e) => {
            onChangeInput(e.target.value, 'search');
          }}
        />
        <Button type="submit">Buscar</Button>
      </Box>
      <TablePostVenta
        title="Repuestos"
        dataTable={spareParts}
        columns={columns}
      />
    </>
  );
};

export default MotomaxFinder;
